import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postWorkType({ body }) {
  return BaseService.post(REST.WORK_TYPE, body);
}

function putWorkType({ body, id }) {
  return BaseService.put(REST.WORK_TYPE_ID(id), body);
}

function getWorkTypes(params) {
  return BaseService.get(REST.WORK_TYPE, {
    params: paramsFilter({ params }),
  });
}

function deleteWorkTypes({ id }) {
  return BaseService.delete(REST.WORK_TYPE_ID(id));
}

export default {
  postWorkType,
  putWorkType,
  getWorkTypes,
  deleteWorkTypes,
};
